module.exports = __webpack_public_path__ + "static/media/latestbook.f2e5866b.png";